<div class="card card-box editor-card">
  <div class="card-header py-3 d-none">
    <div class="card-header--title font-size-lg">
      Template
    </div>
    @if (showSizeToolbar()) {
    <div class="card-header--actions pull-right">
      <app-device-toolbar
        (onPageSizeChange)="onPageSizeSelect($event)"
        (openCodeEditor)="onEditHtml()"></app-device-toolbar>
    </div>
    }
  </div>
  <div class="card-body p-0">
    <div class="row editor-row">
      <div class="col-md-3 pe-0">
        <div class="custom-sidebar" [hidden]="panelCollapsed()" [style]="sideBarCustomStyle()" [style.width.px]="panelCollapsed() ? 0 : panelWidth()">
          <div class="side-top-bar" [style.width.px]="panelCollapsed() ? 0 : panelWidth()">
            <div class='mb-3 bg-light w-100 d-flex justify-content-center'>
              <div class='col-md-6 d-flex justify-content-center'>
                <button (click)='onListIconClick()' class='btn mx-auto' style='outline: none; box-shadow: none;'>
                  <i class='fa fa-list {{ currentMode === modes.RAW_TEMPLATE_LISTING ? "active" : "" }}'
                     aria-hidden='true'></i>
                </button>
              </div>
              <div class='col-md-6 d-flex justify-content-center'>
                <button (click)='onBrushIconClick()' class='btn' style='outline: none; box-shadow: none;'>
                  <i class='fa fa-paint-brush {{ currentMode === modes.TOOL_BAR ? "active" : "" }}'
                     aria-hidden='true'></i>
                </button>
              </div>
            </div>
            @if (currentMode === modes.RAW_TEMPLATE_LISTING && showBlockSelector()) {
            <div class='w-100'>
              <div class='mb-3 ps-3 pe-3' [class.d-none]="hideTemplateSelection()">
                <select class='form-select w-100' [(ngModel)]="this.selectedRawType"
                        (change)="onRawTemplateTypeChange($event)">
                  @for (item of rawTemplatesTypes(); track item) {
                    <option [value]='item.id'
                            style="text-transform:capitalize;">{{item.name}}</option>
                  }
                </select>
              </div>
            </div>
            }
          </div>
          <div class="page-section-design"
               [class.page-properties]="currentMode === modes.TOOL_BAR">
            <div class="page-designer-toolbar-container" cdkDropListGroup>
              <div class='p-0 bg-white container-container'>
                @if (currentMode === modes.RAW_TEMPLATE_LISTING) {
                <div class='w-100'>
                  <div class='container side-bar ps-3 pe-3' cdkDropList [cdkDropListData]="templates()" [class.empty]="templates().length === 0">
                    @if (templates().length > 0) {
                      @for (item of templates(); track item) {
                      <div class='card mb-3 block' (click)='addBlock(item)'>
                        <a><img src="{{item['thumbnail']?item['thumbnail']:'/assets/images/block_placeholder.png'}}"
                                class='card-img'/></a>
                        @if (item.width && item.width && item.aspect_ratio) {
                        <a style="margin: auto;">{{item.width}} x {{item.height}} ({{item.aspect_ratio}})</a>
                        }
                      </div>
                      }
                    } @else {
                      <div class='d-flex justify-content-center mb-3 block empty-message'>
                        No {{templateType() === "socialShare" ? 'Templates' : 'Sections'}} available
                      </div>
                    }
                  </div>
                </div>
                }

                @if (currentMode === modes.TOOL_BAR) {
                <div class="w-100 h-100">
                  @if (showLandingPageEnable()) {
                  <div class='d-flex align-items-center ps-3 py-2'>
                    <input id="landing_page_active" placeholder="" type="checkbox" class="me-1"
                           [checked]="landingPageEnabled()"
                           (change)="landingPageEnabledChange.emit($event.target.checked)">
                    <label for="landing_page_active" class="m-0">Landing Page Enabled</label>
                  </div>
                  }
                  <div class='mb-3 ps-3'>
                    <small>PAGE SETTINGS</small>
                  </div>

                  <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -- ids and codes arrive as numbers or strings -->
                  @if (templateType() === 'socialShare'  || templateType() === 'social_media_post' || templateType()?.slug === 'social_media_post' || template()?.template_type_id == 4) {
                  <div class='accordion' id='imagePropertiesAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='imageProperties'>
                        <small>Properties</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['imageProperties']"
                                aria-controls='imageSettingsContainer'
                                (click)="currentToolBar['imageProperties'] = !currentToolBar['imageProperties']">
                          <i class='fa fa-{{ !currentToolBar["imageProperties"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>
                      <div class='pt-3 collapse' id='imageSettingsContainer' aria-labelledby='imageProperties'
                           [class.show]="currentToolBar['imageProperties']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="predefined_size"><small>Social Network Size</small></label>
                              <div class='input-group input-group-sm'>
                                <select id="predefined_size" class="form-control"
                                        [(ngModel)]="selectedPredefinedSize"
                                        (change)="onPredefinedSizeChange($event.target.value)"
                                        style="height: 35px;">
                                  <option value="">-- Select size --</option>
                                  @for (size of socialImageSizes(); track size) {
                                  <option [value]="size.id">
                                    {{ size.name }} ({{size.width}}x{{size.height}})
                                  </option>
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="image_width"><small>Width</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="image_width" style="height: 36px;" class='form-control' type='number'
                                       data-field='image_width' data-unit="px"
                                       (change)="onWidthHeightChange($event.target.value, 'image_width')"
                                       value="{{pageSetting().image_width || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="image_height"><small>Height</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="image_height" style="height: 36px;" class='form-control' type='number'
                                       data-field='image_height' data-unit="px"
                                       (change)="onWidthHeightChange($event.target.value, 'image_height')"
                                       value="{{pageSetting().image_height || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>                          
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="image_aspect_ratio"><small>Aspect Ratio</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="image_aspect_ratio" style="height: 36px;" class='form-control' type='text' disabled
                                       data-field='image_aspect_ratio' data-unit="px"
                                       value="{{pageSetting().image_aspect_ratio || ''}}"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }

                  <div class='accordion' id='bodyPropertiesAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='bodyProperties'>
                        <small>Body Properties</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['bodyProperties']"
                                aria-controls='bodySettingsContainer'
                                (click)="currentToolBar['bodyProperties'] = !currentToolBar['bodyProperties']">
                          <i class='fa fa-{{ !currentToolBar["bodyProperties"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='bodySettingsContainer' aria-labelledby='bodyProperties'
                           [class.show]="currentToolBar['bodyProperties']">
                        <div class='mb-3'>
                          @if (templateType() !== 'socialShare'  && templateType() !== 'social_media_post' && templateType()?.slug !== 'social_media_post' && template()?.template_type_id !== 4) {
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="max_width"><small>Width</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="max_width" style="height: 36px;" class='form-control' type='number' [disabled]='templateType() === "socialShare"'
                                       data-field='max_width' data-unit="px" min="0"
                                       (change)="onStylesCustomizationChange($event.target.value, 'max_width')"
                                       value="{{pageSetting().max_width || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>
                          }
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="margin_top"><small>Margin Top</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="margin_top" style="height: 36px;" class='form-control' type='number'
                                       data-field='margin_top' data-unit="px"
                                       (change)="onStylesCustomizationChange($event.target.value, 'margin_top')"
                                       value="{{pageSetting().margin_top || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class='accordion' id='blockPropertiesAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='blockProperties'>
                        <small>Blocks Properties</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['blockProperties']"
                                aria-controls='blockSettingsContainer'
                                (click)="currentToolBar['blockProperties'] = !currentToolBar['blockProperties']">
                          <i class='fa fa-{{ !currentToolBar["blockProperties"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='blockSettingsContainer' aria-labelledby='blockProperties'
                           [class.show]="currentToolBar['blockProperties']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="block_margin"><small>Margin</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="block_margin" style="height: 36px;" class='form-control' type='number'
                                       data-field='block_margin' data-unit="px"
                                       (change)="onStylesCustomizationChange($event.target.value, 'block_margin')"
                                       value="{{pageSetting().block_margin || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="block_padding"><small>Padding</small></label>
                              <div class='input-group input-group-sm'>
                                <input id="block_padding" style="height: 36px;" class='form-control' type='number'
                                       data-field='block_padding' data-unit="px" min="0"
                                       (change)="onStylesCustomizationChange($event.target.value, 'block_padding')"
                                       value="{{pageSetting().block_padding || ''}}"/>
                                <span class='input-group-text'>px</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class='accordion' id='colorSettingsAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='colorSettings'>
                        <small>Colors</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['colorSettings']" aria-controls='colorSettingsContainer'
                                (click)="currentToolBar['colorSettings'] = !currentToolBar['colorSettings']">
                          <i class='fa fa-{{ !currentToolBar["colorSettings"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='colorSettingsContainer' aria-labelledby='colorSettings'
                           [class.show]="currentToolBar['colorSettings']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='background_color'><small>Background</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="background_color"
                                        [value]="pageSetting().background_color"
                                        [class]="'form-control'"
                                        [extraColors]="extraColors"
                                        (change)="onStylesCustomizationChange($event.target.value, 'background_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="block_background"><small>Block Background</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="block_background"
                                                  [value]="pageSetting().block_background"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'block_background')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='font_color'><small>Text</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="font_color"
                                                  [value]="pageSetting().font_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'font_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header_font_color'><small>Headings</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="header_font_color"
                                                  [value]="pageSetting().header_font_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'header_font_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='link_color'><small>Link</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="link_color"
                                                  [value]="pageSetting().link_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'link_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='button_color'><small>Button</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="button_color"
                                                  [value]="pageSetting().button_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'button_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='button_font_color'><small>Button Text</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="button_font_color"
                                                  [value]="pageSetting().button_font_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'button_font_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="button_border_color"><small>Button Border</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="button_border_color"
                                                  [value]="pageSetting().button_border_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'button_border_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for="button_hover_color"><small>Button Hover</small></label>
                              <div class='input-group input-group-sm color-input'>
                                <app-color-picker id="button_hover_color"
                                                  [value]="pageSetting().button_hover_color"
                                                  [class]="'form-control'"
                                                  [extraColors]="extraColors"
                                                  (change)="onStylesCustomizationChange($event.target.value, 'button_hover_color')">
                                </app-color-picker>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class='accordion' id='fontStylesAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='fontStyles'>
                        <small>Fonts</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['fontStyles']"
                                aria-controls='fontStylesContainer'
                                (click)="currentToolBar['fontStyles'] = !currentToolBar['fontStyles']">
                          <i class='fa fa-{{ !currentToolBar["fontStyles"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='fontStylesContainer' aria-labelledby='fontStyles'
                           [class.show]="currentToolBar['fontStyles']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='font_family'><small>Text</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().font_family || ''}}" id="font_family" appFontPicker
                                       class='form-control'
                                       type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "font_family")'/>
                              </div>
                            </div>
                          </div>
                          <div class='row'>
                            <!--          appFontPicker-->
                            <!--          class='form-control' type='text'-->
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header1_font_family'><small>Heading 1</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header1_font_family || ''}}" id="header1_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header1_font_family")'/>
                              </div>
                            </div>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header2_font_family'><small>Heading 2</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header2_font_family || ''}}" id="header2_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header2_font_family")'/>
                              </div>
                            </div>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header3_font_family'><small>Heading 3</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header3_font_family || ''}}" id="header3_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header3_font_family")'/>
                              </div>
                            </div>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header4_font_family'><small>Heading 4</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header4_font_family || ''}}" id="header4_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header4_font_family")'/>
                              </div>
                            </div>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header5_font_family'><small>Heading 5</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header5_font_family || ''}}" id="header5_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header5_font_family")'/>
                              </div>
                            </div>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='header6_font_family'><small>Heading 6</small></label>
                              <div class='input-group input-group-sm'>
                                <input value="{{pageSetting().header6_font_family || ''}}" id="header6_font_family"
                                       appFontPicker
                                       class='form-control' type='text'
                                       (change)='onStylesCustomizationChange($event.target.value, "header6_font_family")'/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class='accordion' id='customCSSAccordion'>
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='customCssSettings'>
                        <small>Custom Css</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['customCssSettings']" aria-controls='customCSSContainer'
                                (click)="currentToolBar['customCssSettings'] = !currentToolBar['customCssSettings']">
                          <i class='fa fa-{{ !currentToolBar["customCssSettings"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='customCSSContainer'
                           [class.show]="currentToolBar['customCssSettings']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='background_color'><small>Custom Css</small></label>
                              <div class='input-group input-group-sm'>
                    <textarea class="form-control custom-css" [value]="pageSetting().custom_css || ''"
                              (keyup)="onStylesCustomizationChange($event.target.value, 'custom_css')">
                    </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class='accordion' id='customJavascriptAccordion' style="margin-bottom: 50px">
                    <div class='card card-box'>
                      <div class='card-header py-0 pe-0 ps-3 header-color' id='customJavascriptSettings'>
                        <small>Custom HTML Code</small>
                        <button class='btn btn-link ms-auto' type='button'
                                [attr.aria-expanded]="currentToolBar['customJavascriptSettings']" aria-controls='customJavascriptContainer'
                                (click)="currentToolBar['customJavascriptSettings'] = !currentToolBar['customJavascriptSettings']">
                          <i class='fa fa-{{ !currentToolBar["customJavascriptSettings"] ? "plus" : "minus" }}'></i>
                        </button>
                      </div>

                      <div class='pt-3 collapse' id='customJavascriptContainer'
                           [class.show]="currentToolBar['customJavascriptSettings']">
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='background_color'><small>Head</small></label>
                              <div class='input-group input-group-sm'>
                    <textarea class="form-control custom-javascript" [value]="pageSetting().custom_html_head_code || ''"
                              (keyup)="onStylesCustomizationChange($event.target.value, 'custom_html_head_code')" placeholder="<script>console.log('test')</script>">
                    </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class='mb-3'>
                          <div class='row'>
                            <div class='col-md-9 mb-3 mx-auto'>
                              <label for='background_color'><small>Body</small></label>
                              <div class='input-group input-group-sm'>
                    <textarea class="form-control custom-javascript" [value]="pageSetting().custom_html_body_code || ''"
                              (keyup)="onStylesCustomizationChange($event.target.value, 'custom_html_body_code')" placeholder="<script>console.log('test')</script>">
                    </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid {{customClasses()}}" [class.d-none]="!templateLoaded">
        <div class="col-md-12 p-0">
          <app-page-designer
            [token]="token"
            #pageDesigner [ViewportSize]="viewportSize()"
            [ImageAutoCropEnabled]="$safeNavigationMigration(template()?.auto_crop_enabled)"
            [ImageProcessLimits]="$safeNavigationMigration(template()?.image_process_limits)"
            [Variables]="getVariablesForPageDesigner()"
            (OnContentChanged)="OnContentChanged.emit()"></app-page-designer>
        </div>
      </div>
      <div class="container-fluid loader-div" [class.d-none]="templateLoaded">
        <div class="col-md-12 p-0 loader">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
  <ng-template #codeEditor let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Template HTML</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click');"></button>
    </div>
    <div class="modal-body">
      <textarea class="code-view" (blur)="updateHtmlBody($event)"
                autocomplete="off" autocapitalize="off"
                spellcheck="false">{{editHtml.htmlBody}}</textarea>
    </div>
    <div class="modal-footer">
      <button (click)="modal.close(true)" class="btn btn-primary me-2">
        <span>Apply</span>
      </button>
      <button (click)="modal.dismiss('Close clicked');" class="btn btn-default me-2">
        <span>Cancel</span>
      </button>
    </div>
  </ng-template>
</div>
